/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/interactive-supports-focus, jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
/* eslint-disable consistent-return */

import React, { useEffect, useState } from 'react';
import { useLanguage } from '@components/common/locale/useLanguage';
export default function BusyPopup(_ref) {
  var {
    onClose,
    redirectToHome
  } = _ref;
  var [isVisible, setIsVisible] = useState(false);
  var [shouldRender, setShouldRender] = useState(false);
  var {
    isAr
  } = useLanguage();
  useEffect(() => {
    // Delay showing the popup by 1 second
    var showTimer = setTimeout(() => {
      setShouldRender(true);
      // Small delay to trigger animation after render
      setTimeout(() => setIsVisible(true), 50);
    }, 1000);
    return () => clearTimeout(showTimer);
  }, []);
  var handleClose = () => {
    setIsVisible(false);
    // Wait for animation to finish before unmounting
    setTimeout(() => {
      if (onClose) onClose();
      if (redirectToHome) {
        window.location.href = '/';
      }
    }, 300);
  };

  // Prevent body scroll when popup is open
  useEffect(() => {
    if (shouldRender) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [shouldRender]);
  if (!shouldRender) return null;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "fixed inset-0 bg-black z-[99] transition-opacity duration-300 ".concat(isVisible ? 'opacity-70' : 'opacity-0'),
    onClick: handleClose
  }), /*#__PURE__*/React.createElement("div", {
    dir: isAr ? 'rtl' : 'ltr',
    className: "fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-[#F7F7F7] md:w-[60.5rem] w-[calc(100%-3rem)] max-w-[33rem] md:max-w-none flex flex-col items-center rounded-[0.73rem] md:rounded-[0.705rem] gap-[1.8rem] md:pt-[2.9rem] md:pb-[3.2rem] md:px-[6.1rem] px-[2.5rem] pt-[2.5rem] pb-[3rem] transition-all duration-300 ".concat(isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95')
  }, /*#__PURE__*/React.createElement("div", {
    role: "button",
    onClick: handleClose,
    className: "absolute md:top-11 top-8 ".concat(isAr ? 'md:left-11 left-9' : 'md:right-11 right-9', " cursor-pointer")
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "md:w-[2.1rem] md:h-[2.1rem] w-[1.7rem] h-[1.7rem]",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2791 18.2198C19.3488 18.2895 19.404 18.3722 19.4418 18.4632C19.4795 18.5543 19.4989 18.6519 19.4989 18.7504C19.4989 18.849 19.4795 18.9465 19.4418 19.0376C19.404 19.1286 19.3488 19.2114 19.2791 19.281C19.2094 19.3507 19.1267 19.406 19.0356 19.4437C18.9446 19.4814 18.847 19.5008 18.7485 19.5008C18.6499 19.5008 18.5523 19.4814 18.4613 19.4437C18.3702 19.406 18.2875 19.3507 18.2178 19.281L11.9985 13.0607L5.77909 19.281C5.63836 19.4218 5.44749 19.5008 5.24846 19.5008C5.04944 19.5008 4.85857 19.4218 4.71784 19.281C4.57711 19.1403 4.49805 18.9494 4.49805 18.7504C4.49805 18.5514 4.57711 18.3605 4.71784 18.2198L10.9382 12.0004L4.71784 5.78104C4.57711 5.64031 4.49805 5.44944 4.49805 5.25042C4.49805 5.05139 4.57711 4.86052 4.71784 4.71979C4.85857 4.57906 5.04944 4.5 5.24846 4.5C5.44749 4.5 5.63836 4.57906 5.77909 4.71979L11.9985 10.9401L18.2178 4.71979C18.3586 4.57906 18.5494 4.5 18.7485 4.5C18.9475 4.5 19.1384 4.57906 19.2791 4.71979C19.4198 4.86052 19.4989 5.05139 19.4989 5.25042C19.4989 5.44944 19.4198 5.64031 19.2791 5.78104L13.0588 12.0004L19.2791 18.2198Z",
    fill: "#C60910"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center flex-col gap-[0.4rem] md:gap-[0.9rem]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mt-[-0.8rem] md:mt-0"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "md:w-[13rem] md:h-[10rem] w-[8rem] h-[7rem]",
    viewBox: "0 0 106 113",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5727 0H7.05273V3.51993H10.5727V0Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0922 0H10.5723V3.51993H14.0922V0Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6264 0H14.1064V3.51993H17.6264V0Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6654 0H21.1455V3.51993H24.6654V0Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1977 0H24.6777V3.51993H28.1977V0Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7182 0H28.1982V3.51993H31.7182V0Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5727 3.53125H7.05273V7.05118H10.5727V3.53125Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0922 3.53125H10.5723V7.05118H14.0922V3.53125Z",
    fill: "#CF221E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6264 3.53125H14.1064V7.05118H17.6264V3.53125Z",
    fill: "#CF221E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1459 3.53125H17.626V7.05118H21.1459V3.53125Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6654 3.53125H21.1455V7.05118H24.6654V3.53125Z",
    fill: "#CF221E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1977 3.53125H24.6777V7.05118H28.1977V3.53125Z",
    fill: "#CF221E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7182 3.53125H28.1982V7.05118H31.7182V3.53125Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2524 3.53125H31.7324V7.05118H35.2524V3.53125Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5727 7.05469H7.05273V10.5746H10.5727V7.05469Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0922 7.05469H10.5723V10.5746H14.0922V7.05469Z",
    fill: "#CF221E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6264 7.05469H14.1064V10.5746H17.6264V7.05469Z",
    fill: "#CF221E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1459 7.05469H17.626V10.5746H21.1459V7.05469Z",
    fill: "#612721"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6654 7.05469H21.1455V10.5746H24.6654V7.05469Z",
    fill: "#CF221E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1977 7.05469H24.6777V10.5746H28.1977V7.05469Z",
    fill: "#CF221E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7182 7.05469H28.1982V10.5746H31.7182V7.05469Z",
    fill: "#612721"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2524 7.05469H31.7324V10.5746H35.2524V7.05469Z",
    fill: "#CF221E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7719 7.05469H35.252V10.5746H38.7719V7.05469Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0922 10.5859H10.5723V14.1059H14.0922V10.5859Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6264 10.5859H14.1064V14.1059H17.6264V10.5859Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7182 10.5859H28.1982V14.1059H31.7182V10.5859Z",
    fill: "#CF221E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2524 10.5859H31.7324V14.1059H35.2524V10.5859Z",
    fill: "#CF221E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7719 10.5859H35.252V14.1059H38.7719V10.5859Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0922 14.1094H10.5723V17.6293H14.0922V14.1094Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6264 14.1094H14.1064V17.6293H17.6264V14.1094Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7182 14.1094H28.1982V17.6293H31.7182V14.1094Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2524 14.1094H31.7324V17.6293H35.2524V14.1094Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5727 17.625H7.05273V21.1449H10.5727V17.625Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9091 17.3516H10.1914V21.0693H13.9091V17.3516Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6264 17.625H14.1064V21.1449H17.6264V17.625Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3679 17.8938L22.8789 20.3828L25.3679 22.8718L27.8569 20.3828L25.3679 17.8938Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2524 17.625H31.7324V21.1449H35.2524V17.625Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7719 17.625H35.252V21.1449H38.7719V17.625Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5971 17.625H81.0771V21.1449H84.5971V17.625Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1293 17.625H84.6094V21.1449H88.1293V17.625Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6498 17.625H88.1299V21.1449H91.6498V17.625Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03946 21.1562H3.51953V24.6762H7.03946V21.1562Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5727 21.1562H7.05273V24.6762H10.5727V21.1562Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9091 21.0703H10.1914V24.788H13.9091V21.0703Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6259 21.0703H13.9082V24.788H17.6259V21.0703Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.906 20.4329L20.417 22.9219L22.906 25.4109L25.3949 22.9219L22.906 20.4329Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4382 17.9642L17.9492 20.4531L20.4382 22.9421L22.9272 20.4531L20.4382 17.9642Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.487 22.8235L17.998 25.3125L20.487 27.8015L22.976 25.3125L20.487 22.8235Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3718 22.8704L22.8828 25.3594L25.3718 27.8484L27.8608 25.3594L25.3718 22.8704Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7719 21.1562H35.252V24.6762H38.7719V21.1562Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0766 21.1562H77.5566V24.6762H81.0766V21.1562Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5971 21.1562H81.0771V24.6762H84.5971V21.1562Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1293 21.1562H84.6094V24.6762H88.1293V21.1562Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6498 21.1562H88.1299V24.6762H91.6498V21.1562Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.183 21.1562H91.6631V24.6762H95.183V21.1562Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7035 21.1562H95.1836V24.6762H98.7035V21.1562Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51993 24.6797H0V28.1996H3.51993V24.6797Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03946 24.6797H3.51953V28.1996H7.03946V24.6797Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5727 24.6797H7.05273V28.1996H10.5727V24.6797Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9091 24.7812H10.1914V28.4989H13.9091V24.7812Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6259 24.7812H13.9082V28.4989H17.6259V24.7812Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7719 24.6797H35.252V28.1996H38.7719V24.6797Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2924 24.6797H38.7725V28.1996H42.2924V24.6797Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.557 24.6797H74.0371V28.1996H77.557V24.6797Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0766 24.6797H77.5566V28.1996H81.0766V24.6797Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5971 24.6797H81.0771V28.1996H84.5971V24.6797Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1293 24.6797H84.6094V28.1996H88.1293V24.6797Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6498 24.6797H88.1299V28.1996H91.6498V24.6797Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.183 24.6797H91.6631V28.1996H95.183V24.6797Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7035 24.6797H95.1836V28.1996H98.7035V24.6797Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.223 24.6797H98.7031V28.1996H102.223V24.6797Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51993 28.2109H0V31.7309H3.51993V28.2109Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03946 28.2109H3.51953V31.7309H7.03946V28.2109Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5727 28.2109H7.05273V31.7309H10.5727V28.2109Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0922 28.2109H10.5723V31.7309H14.0922V28.2109Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6264 28.2109H14.1064V31.7309H17.6264V28.2109Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2924 28.2109H38.7725V31.7309H42.2924V28.2109Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8783 28.2109H49.3584V31.7309H52.8783V28.2109Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3979 28.2109H52.8779V31.7309H56.3979V28.2109Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9184 28.2109H56.3984V31.7309H59.9184V28.2109Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4506 28.2109H59.9307V31.7309H63.4506V28.2109Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9701 28.2109H63.4502V31.7309H66.9701V28.2109Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5033 28.2109H66.9834V31.7309H70.5033V28.2109Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0248 28.2109H70.5049V31.7309H74.0248V28.2109Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.557 28.2109H74.0371V31.7309H77.557V28.2109Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0766 28.2109H77.5566V31.7309H81.0766V28.2109Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5971 28.2109H81.0771V31.7309H84.5971V28.2109Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1293 28.2109H84.6094V31.7309H88.1293V28.2109Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6498 28.2109H88.1299V31.7309H91.6498V28.2109Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.183 28.2109H91.6631V31.7309H95.183V28.2109Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7035 28.2109H95.1836V31.7309H98.7035V28.2109Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.223 28.2109H98.7031V31.7309H102.223V28.2109Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0922 31.7344H10.5723V35.2543H14.0922V31.7344Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6264 31.7344H14.1064V35.2543H17.6264V31.7344Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2924 31.7344H38.7725V35.2543H42.2924V31.7344Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8246 31.7344H42.3047V35.2543H45.8246V31.7344Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3442 31.7344H45.8242V35.2543H49.3442V31.7344Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8783 31.7344H49.3584V35.2543H52.8783V31.7344Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3979 31.7344H52.8779V35.2543H56.3979V31.7344Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9184 31.7344H56.3984V35.2543H59.9184V31.7344Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4506 31.7344H59.9307V35.2543H63.4506V31.7344Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9701 31.7344H63.4502V35.2543H66.9701V31.7344Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5033 31.7344H66.9834V35.2543H70.5033V31.7344Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0248 31.7344H70.5049V35.2543H74.0248V31.7344Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.557 31.7344H74.0371V35.2543H77.557V31.7344Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0766 31.7344H77.5566V35.2543H81.0766V31.7344Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5971 31.7344H81.0771V35.2543H84.5971V31.7344Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1293 31.7344H84.6094V35.2543H88.1293V31.7344Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6498 31.7344H88.1299V35.2543H91.6498V31.7344Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.183 31.7344H91.6631V35.2543H95.183V31.7344Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7035 31.7344H95.1836V35.2543H98.7035V31.7344Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.223 31.7344H98.7031V35.2543H102.223V31.7344Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.755 31.7344H102.235V35.2543H105.755V31.7344Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6264 35.2656H14.1064V38.7855H17.6264V35.2656Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1459 35.2656H17.626V38.7855H21.1459V35.2656Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2924 35.2656H38.7725V38.7855H42.2924V35.2656Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8246 35.2656H42.3047V38.7855H45.8246V35.2656Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3442 35.2656H45.8242V38.7855H49.3442V35.2656Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8783 35.2656H49.3584V38.7855H52.8783V35.2656Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3979 35.2656H52.8779V38.7855H56.3979V35.2656Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9184 35.2656H56.3984V38.7855H59.9184V35.2656Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4506 35.2656H59.9307V38.7855H63.4506V35.2656Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0766 35.2656H77.5566V38.7855H81.0766V35.2656Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5971 35.2656H81.0771V38.7855H84.5971V35.2656Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1293 35.2656H84.6094V38.7855H88.1293V35.2656Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6498 35.2656H88.1299V38.7855H91.6498V35.2656Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.183 35.2656H91.6631V38.7855H95.183V35.2656Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7035 35.2656H95.1836V38.7855H98.7035V35.2656Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.223 35.2656H98.7031V38.7855H102.223V35.2656Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.755 35.2656H102.235V38.7855H105.755V35.2656Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6264 38.7891H14.1064V42.309H17.6264V38.7891Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1459 38.7891H17.626V42.309H21.1459V38.7891Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2924 38.7891H38.7725V42.309H42.2924V38.7891Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8246 38.7891H42.3047V42.309H45.8246V38.7891Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5971 38.7891H81.0771V42.309H84.5971V38.7891Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1293 38.7891H84.6094V42.309H88.1293V38.7891Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6498 38.7891H88.1299V42.309H91.6498V38.7891Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.183 38.7891H91.6631V42.309H95.183V38.7891Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7035 38.7891H95.1836V42.309H98.7035V38.7891Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.223 38.7891H98.7031V42.309H102.223V38.7891Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6264 42.3047H14.1064V45.8246H17.6264V42.3047Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1459 42.3047H17.626V45.8246H21.1459V42.3047Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3979 42.3047H52.8779V45.8246H56.3979V42.3047Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9184 42.3047H56.3984V45.8246H59.9184V42.3047Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4506 42.3047H59.9307V45.8246H63.4506V42.3047Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9701 42.3047H63.4502V45.8246H66.9701V42.3047Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5033 42.3047H66.9834V45.8246H70.5033V42.3047Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0248 42.3047H70.5049V45.8246H74.0248V42.3047Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1293 42.3047H84.6094V45.8246H88.1293V42.3047Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6498 42.3047H88.1299V45.8246H91.6498V42.3047Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.183 42.3047H91.6631V45.8246H95.183V42.3047Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7035 42.3047H95.1836V45.8246H98.7035V42.3047Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6264 45.8359H14.1064V49.3559H17.6264V45.8359Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1459 45.8359H17.626V49.3559H21.1459V45.8359Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4506 45.8359H59.9307V49.3559H63.4506V45.8359Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9701 45.8359H63.4502V49.3559H66.9701V45.8359Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5033 45.8359H66.9834V49.3559H70.5033V45.8359Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0248 45.8359H70.5049V49.3559H74.0248V45.8359Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.557 45.8359H74.0371V49.3559H77.557V45.8359Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1293 45.8359H84.6094V49.3559H88.1293V45.8359Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6498 45.8359H88.1299V49.3559H91.6498V45.8359Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.183 45.8359H91.6631V49.3559H95.183V45.8359Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6264 49.3594H14.1064V52.8793H17.6264V49.3594Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1459 49.3594H17.626V52.8793H21.1459V49.3594Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.557 49.3594H74.0371V52.8793H77.557V49.3594Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1293 49.3594H84.6094V52.8793H88.1293V49.3594Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6498 49.3594H88.1299V52.8793H91.6498V49.3594Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6264 52.8906H14.1064V56.4106H17.6264V52.8906Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1459 52.8906H17.626V56.4106H21.1459V52.8906Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2924 52.8906H38.7725V56.4106H42.2924V52.8906Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9184 52.8906H56.3984V56.4106H59.9184V52.8906Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4506 52.8906H59.9307V56.4106H63.4506V52.8906Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9701 52.8906H63.4502V56.4106H66.9701V52.8906Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5033 52.8906H66.9834V56.4106H70.5033V52.8906Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0248 52.8906H70.5049V56.4106H74.0248V52.8906Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.557 52.8906H74.0371V56.4106H77.557V52.8906Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1293 52.8906H84.6094V56.4106H88.1293V52.8906Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6264 56.4141H14.1064V59.934H17.6264V56.4141Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1459 56.4141H17.626V59.934H21.1459V56.4141Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8246 56.4141H42.3047V59.934H45.8246V56.4141Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.557 56.4141H74.0371V59.934H77.557V56.4141Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1293 56.4141H84.6094V59.934H88.1293V56.4141Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6264 59.9297H14.1064V63.4496H17.6264V59.9297Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1459 59.9297H17.626V63.4496H21.1459V59.9297Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6654 59.9297H21.1455V63.4496H24.6654V59.9297Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8246 59.9297H42.3047V63.4496H45.8246V59.9297Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3442 59.9297H45.8242V63.4496H49.3442V59.9297Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9184 59.9297H56.3984V63.4496H59.9184V59.9297Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4506 59.9297H59.9307V63.4496H63.4506V59.9297Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9701 59.9297H63.4502V63.4496H66.9701V59.9297Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5033 59.9297H66.9834V63.4496H70.5033V59.9297Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0248 59.9297H70.5049V63.4496H74.0248V59.9297Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.557 59.9297H74.0371V63.4496H77.557V59.9297Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5971 59.9297H81.0771V63.4496H84.5971V59.9297Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1293 59.9297H84.6094V63.4496H88.1293V59.9297Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1459 63.4688H17.626V66.9887H21.1459V63.4688Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6654 63.4688H21.1455V66.9887H24.6654V63.4688Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3442 63.4688H45.8242V66.9887H49.3442V63.4688Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8783 63.4688H49.3584V66.9887H52.8783V63.4688Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3979 63.4688H52.8779V66.9887H56.3979V63.4688Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5033 63.4688H66.9834V66.9887H70.5033V63.4688Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0248 63.4688H70.5049V66.9887H74.0248V63.4688Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5971 63.4688H81.0771V66.9887H84.5971V63.4688Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1459 66.9844H17.626V70.5043H21.1459V66.9844Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6654 66.9844H21.1455V70.5043H24.6654V66.9844Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1977 66.9844H24.6777V70.5043H28.1977V66.9844Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8783 66.9844H49.3584V70.5043H52.8783V66.9844Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3979 66.9844H52.8779V70.5043H56.3979V66.9844Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9184 66.9844H56.3984V70.5043H59.9184V66.9844Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4506 66.9844H59.9307V70.5043H63.4506V66.9844Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9701 66.9844H63.4502V70.5043H66.9701V66.9844Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5033 66.9844H66.9834V70.5043H70.5033V66.9844Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0766 66.9844H77.5566V70.5043H81.0766V66.9844Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5971 66.9844H81.0771V70.5043H84.5971V66.9844Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6654 70.5156H21.1455V74.0356H24.6654V70.5156Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1977 70.5156H24.6777V74.0356H28.1977V70.5156Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7182 70.5156H28.1982V74.0356H31.7182V70.5156Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0766 70.5156H77.5566V74.0356H81.0766V70.5156Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6654 74.0391H21.1455V77.559H24.6654V74.0391Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1977 74.0391H24.6777V77.559H28.1977V74.0391Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7182 74.0391H28.1982V77.559H31.7182V74.0391Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2524 74.0391H31.7324V77.559H35.2524V74.0391Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7719 74.0391H35.252V77.559H38.7719V74.0391Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.557 74.0391H74.0371V77.559H77.557V74.0391Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1977 77.5547H24.6777V81.0746H28.1977V77.5547Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7182 77.5547H28.1982V81.0746H31.7182V77.5547Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2524 77.5547H31.7324V81.0746H35.2524V77.5547Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7719 77.5547H35.252V81.0746H38.7719V77.5547Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2924 77.5547H38.7725V81.0746H42.2924V77.5547Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8246 77.5547H42.3047V81.0746H45.8246V77.5547Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0248 77.5547H70.5049V81.0746H74.0248V77.5547Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7182 81.0938H28.1982V84.6137H31.7182V81.0938Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2524 81.0938H31.7324V84.6137H35.2524V81.0938Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7719 81.0938H35.252V84.6137H38.7719V81.0938Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2924 81.0938H38.7725V84.6137H42.2924V81.0938Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8246 81.0938H42.3047V84.6137H45.8246V81.0938Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3442 81.0938H45.8242V84.6137H49.3442V81.0938Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9701 81.0938H63.4502V84.6137H66.9701V81.0938Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5033 81.0938H66.9834V84.6137H70.5033V81.0938Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2524 84.6094H31.7324V88.1293H35.2524V84.6094Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7719 84.6094H35.252V88.1293H38.7719V84.6094Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2924 84.6094H38.7725V88.1293H42.2924V84.6094Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8246 84.6094H42.3047V88.1293H45.8246V84.6094Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3442 84.6094H45.8242V88.1293H49.3442V84.6094Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8783 84.6094H49.3584V88.1293H52.8783V84.6094Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9701 84.6094H63.4502V88.1293H66.9701V84.6094Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7719 88.1406H35.252V91.6606H38.7719V88.1406Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2924 88.1406H38.7725V91.6606H42.2924V88.1406Z",
    fill: "#E88A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8246 88.1406H42.3047V91.6606H45.8246V88.1406Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8783 88.1406H49.3584V91.6606H52.8783V88.1406Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3979 88.1406H52.8779V91.6606H56.3979V88.1406Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4506 88.1406H59.9307V91.6606H63.4506V88.1406Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9701 88.1406H63.4502V91.6606H66.9701V88.1406Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7719 91.6641H35.252V95.184H38.7719V91.6641Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2924 91.6641H38.7725V95.184H42.2924V91.6641Z",
    fill: "#E88A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8246 91.6641H42.3047V95.184H45.8246V91.6641Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3979 91.6641H52.8779V95.184H56.3979V91.6641Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9184 91.6641H56.3984V95.184H59.9184V91.6641Z",
    fill: "#E88A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4506 91.6641H59.9307V95.184H63.4506V91.6641Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7719 95.1875H35.252V98.7074H38.7719V95.1875Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2924 95.1875H38.7725V98.7074H42.2924V95.1875Z",
    fill: "#E88A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8246 95.1875H42.3047V98.7074H45.8246V95.1875Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3979 95.1875H52.8779V98.7074H56.3979V95.1875Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9184 95.1875H56.3984V98.7074H59.9184V95.1875Z",
    fill: "#E88A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4506 95.1875H59.9307V98.7074H63.4506V95.1875Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7719 98.7188H35.252V102.239H38.7719V98.7188Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2924 98.7188H38.7725V102.239H42.2924V98.7188Z",
    fill: "#E88A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8246 98.7188H42.3047V102.239H45.8246V98.7188Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3979 98.7188H52.8779V102.239H56.3979V98.7188Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9184 98.7188H56.3984V102.239H59.9184V98.7188Z",
    fill: "#E88A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4506 98.7188H59.9307V102.239H63.4506V98.7188Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7182 102.234H28.1982V105.754H31.7182V102.234Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2524 102.234H31.7324V105.754H35.2524V102.234Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7719 102.234H35.252V105.754H38.7719V102.234Z",
    fill: "#E88A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2924 102.234H38.7725V105.754H42.2924V102.234Z",
    fill: "#E88A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8246 102.234H42.3047V105.754H45.8246V102.234Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3979 102.234H52.8779V105.754H56.3979V102.234Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9184 102.234H56.3984V105.754H59.9184V102.234Z",
    fill: "#E88A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4506 102.234H59.9307V105.754H63.4506V102.234Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7182 105.773H28.1982V109.293H31.7182V105.773Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2524 105.773H31.7324V109.293H35.2524V105.773Z",
    fill: "#E88A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7719 105.773H35.252V109.293H38.7719V105.773Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2924 105.773H38.7725V109.293H42.2924V105.773Z",
    fill: "#F8C53A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8246 105.773H42.3047V109.293H45.8246V105.773Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3979 105.773H52.8779V109.293H56.3979V105.773Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9184 105.773H56.3984V109.293H59.9184V105.773Z",
    fill: "#F8C53A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4506 105.773H59.9307V109.293H63.4506V105.773Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8783 109.289H49.3584V112.809H52.8783V109.289Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3979 109.289H52.8779V112.809H56.3979V109.289Z",
    fill: "#F8C53A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9184 109.289H56.3984V112.809H59.9184V109.289Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4506 109.289H59.9307V112.809H63.4506V109.289Z",
    fill: "#F8C53A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9701 109.289H63.4502V112.809H66.9701V109.289Z",
    fill: "#050403"
  }))), /*#__PURE__*/React.createElement("p", {
    className: "text-[#C60910] font-zoomPro text-[2.2rem] md:text-[2.6rem] uppercase font-[700] text-center"
  }, isAr ? 'المطبخ ممتلئ تمامًا' : 'KITCHEN TOO FULL')), /*#__PURE__*/React.createElement("p", {
    className: "md:w-[48.3rem] md:mt-[-1rem] mt-[-1.5rem] w-[27rem] max-w-full md:text-[2rem] text-[1.4rem] font-[400] text-center text-[#717171] leading-relaxed md:leading-normal"
  }, isAr ? 'نحن حاليًا بكامل طاقتنا الاستيعابية، والطلبات عبر الإنترنت غير متوفرة مؤقتًا. يرجى التحقق مرة أخرى قريبًا. سنستلم طلبك في أقرب وقت ممكن. شكراً لك!' : "We're currently at full capacity, and online orders are temporarily unavailable. Please check back soon. We'll take your order as soon as we can. Thank you!"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: handleClose,
    className: "bg-black hover:bg-neutral-800 text-white font-bold text-[1.3rem] md:text-[1.5rem] px-[2rem] md:px-[2.4rem] py-[0.9rem] md:py-[1.1rem] rounded-full flex items-center justify-center gap-[1rem] transition-colors mt-[0.5rem] cursor-pointer"
  }, isAr ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "w-[2.2rem] h-[2.2rem] md:w-[2.6rem] md:h-[2.6rem] bg-white rounded-full flex items-center justify-center shrink-0"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "w-[1.2rem] h-[1.2rem] md:w-[1.4rem] md:h-[1.4rem]",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "2.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 12H5M12 19l-7-7 7-7"
  }))), /*#__PURE__*/React.createElement("span", null, "\u062A\u0635\u0641\u062D \u0627\u0644\u0645\u0646\u064A\u0648")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "BROWSE MENU"), /*#__PURE__*/React.createElement("span", {
    className: "w-[2.2rem] h-[2.2rem] md:w-[2.6rem] md:h-[2.6rem] bg-white rounded-full flex items-center justify-center shrink-0"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "w-[1.2rem] h-[1.2rem] md:w-[1.4rem] md:h-[1.4rem]",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "2.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 12h14M12 5l7 7-7 7"
  })))))));
}